module.exports = __webpack_public_path__ + "static/media/remove-red.108a83d1.svg";